import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransferRecipientResponse } from '../models/responses/transfer-recipient-response';
import { Observable } from 'rxjs';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class TransferRecipientService {

  constructor(private httpClient: HttpClient) { }

  batchCreate(recipients: TransferRecipientResponse[]) {
    return this.httpClient.post(`${environment.transferUrl}/batchCreate`, { recipients });
  }

  batchUpdate(recipients: TransferRecipientResponse[]) {
    return this.httpClient.post(`${environment.transferUrl}/batchUpdate`, { recipients });
  }

  batchDelete(ids: number[]) {
    return this.httpClient.post(`${environment.transferUrl}/batchDelete`, { ids });
  }

  fetchAll(businessId: number): Observable<TransferRecipientResponse[]> {
    return this.httpClient.get<TransferRecipientResponse[]>(`${environment.transferUrl}/fetchAll/${businessId}`);
  }
}
